const URLS = {
    api: process.env.VUE_APP_API_URL,
    // api: 'http://localhost:3008',
    socketUrl: process.env.VUE_APP_SOCKET_URL,
    app: process.env.VUE_APP_FRONTEND_URL
}

export default URLS